import { axiosPrivate } from "./axios";

const devRulesService = {
  getRules: async () => {
    const response = await axiosPrivate.get("/api/dev-rules");
    return response.data;
  },

  updateRules: async (rules) => {
    const response = await axiosPrivate.put("/api/dev-rules", { rules });
    return response.data;
  },

  getLockState: async () => {
    const response = await axiosPrivate.get("/api/dev-rules/state");
    return response.data;
  },

  acknowledgeLatest: async () => {
    const response = await axiosPrivate.post("/api/dev-rules/acknowledge");
    return response.data;
  },
};

export default devRulesService;
